module.exports = __webpack_public_path__ + "media/images/active_material/icons/search-7e1ce545aff4089e6d435fd71f3cb7b3.svg";